import { SearchUser } from 'phoenix/domain';
import {
	FullTextSearchHit,
	FullTextSearchResults,
	FullTextSearchService,
	SearchBuilder
} from 'sharebase/services/fullTextSearchService';
import { IDataStore } from 'sharebase/domain';
import { ProgressService } from 'phoenix/services';
import { TagService } from 'sharebase/services';

export interface FullTextSearchHitView extends FullTextSearchHit {
	hitHighlightsText: string;
}

export class FullTextSearchDataStore implements IDataStore {
	public static readonly $inject = [
		'$sce',
		'$timeout',
		'gettextCatalog',
		'pxProgressService',
		'sbFullTextSearchService',		
		'sbTagService'
	];

	private sharedContent:FullTextSearchHitView[];
	private ownedContent:FullTextSearchHitView[];
	private builder:SearchBuilder;
	public pending:boolean = false;
	public searchTerm:string;
	public excludeMine:boolean = false;
	public onlyMine:boolean = false;
	private _users:SearchUser[] = [];
	private _tagTypes:string[] = [];

	public requestTimedOut:boolean = false;
	public requestErrorMessage:string;
	private _requestTimedOutTimer:any;
	
	public get tags() { return this._tagTypes; }
	
	public get users(){	return this._users; } 

	public get searchParamsBuilder(): SearchBuilder {
		return this.builder;
	}

	public get shared(): FullTextSearchHitView[] {
		if (!this.sharedContent) {
			return [];
		}

		return this.sharedContent;
	}

	public get owned(): FullTextSearchHitView[] {
		if (!this.ownedContent) {
			return [];
		}

		return this.ownedContent;
	}

	constructor(
		private readonly $sce:ng.ISCEService,
		private readonly $timeout: ng.ITimeoutService,
		private readonly gettextCatalog:any,
		private readonly pxProgressService:ProgressService,
		private readonly searchService:FullTextSearchService,
		private readonly sbTagService:TagService
	) {
		this.sbTagService.getTagTypes()
			.then(res => {
				let myTags = res.filter(t => t.TagTypeName === 'My Tags')[0];
				return this.sbTagService.getTags(myTags);
			})
			.then(tags => this._tagTypes = tags);
	 }

	public load()  {
		this.beginTimeOut();
		let query = this.builder.build();
		this.searchTerm = query.SearchString;
		this.pxProgressService.visible = true;
		this.pending = true;		
		this.requestErrorMessage = null;

		return this.searchService.search(query)
			.then((result: FullTextSearchResults) => {
				this.ownedContent = this.mapResultsFor(result.Result.Owned);
				this.sharedContent= this.mapResultsFor(result.Result.Shared);
				return result.Result;
			})
			.catch(() => {
				this.requestErrorMessage = this.gettextCatalog.getString('There was an error processing your request');
				return {Owned:[],Shared:[]};
			})
			.finally(() => {
				this.cancelTimeOut();
				this.builder.reset();
				this.pxProgressService.visible = false;
				this.pending = false;
			});
	}

	private beginTimeOut(){
		this.requestTimedOut = false;
		this._requestTimedOutTimer = this.$timeout(()=>{
			//timedOut after 10s
			this.requestTimedOut = true;
			this.requestErrorMessage = this.gettextCatalog.getString('Search took too long to respond');
			this.pxProgressService.visible = false;
		},10000);
	}

	private cancelTimeOut(){		
		this.$timeout.cancel(this._requestTimedOutTimer);
		this.requestTimedOut = false;
		this.requestErrorMessage = null;
			
	}

	public clearStore(){
		this.sharedContent = null;
		this.ownedContent = null;
		this.searchTerm = null;
		this.excludeMine = false;
		this._users = [];
		this._tagTypes = [];
		this.requestTimedOut = false;
		this.requestErrorMessage = null;
	}

	public newSearch(query: string = '') {
		this.builder = new SearchBuilder();
		if (query) {
			this.builder.setQueryText(query);
		}

		return this.builder;
	}

	public initSearch() {
		if (!this.builder) {
			this.newSearch();
		}
	}

	private mapResultsFor(results: FullTextSearchHit[]): FullTextSearchHitView[] {
		return results.map((s: FullTextSearchHitView) => {
			if (s.HitHighlights !== null) {
				let highlightText = s.HitHighlights.slice(0, 3);
				let useTrailingDots = highlightText.length > 1;

				s.hitHighlightsText = highlightText.join('... ');
				if (useTrailingDots) {
					s.hitHighlightsText += '...';
				}

				s.hitHighlightsText = this.$sce.trustAsHtml(s.hitHighlightsText);
			}

			return s;
		});

	}
}


// WEBPACK FOOTER //
// ./src/sharebase/dataStores/fullTextSearchDataStore.ts